import { ExcalidrawLogo } from "@excalidraw/excalidraw/components/ExcalidrawLogo";
import { LoadIcon } from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { LanguageList } from "../app-language/LanguageList";
import {
  CLOUD_DASHBOARD_URL,
  CLOUD_DASHBOARD_ENABLED,
  getCloudBoardId,
} from "../data/cloudBoard";

import { ScreenMenu } from "./ScreenMenu";

// The logo doubles as the way back to the dashboard — the "Back to dashboard"
// menu item below stays as a second, labeled way in.
const DashboardLogo = () => (
  <a
    className="top-left-bar__logo"
    href={CLOUD_DASHBOARD_URL}
    title="Back to dashboard"
    data-testid="top-left-bar-dashboard"
  >
    <ExcalidrawLogo size="xs" />
  </a>
);

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  return (
    <MainMenu
      logo={CLOUD_DASHBOARD_ENABLED ? <DashboardLogo /> : undefined}
      screen={<ScreenMenu />}
    >
      {CLOUD_DASHBOARD_ENABLED && (
        <>
          <MainMenu.Item
            icon={LoadIcon}
            onSelect={() => {
              window.location.href = CLOUD_DASHBOARD_URL;
            }}
            data-testid="back-to-dashboard"
          >
            Back to dashboard
          </MainMenu.Item>
          <MainMenu.Separator />
        </>
      )}
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      {/* no promo styling: it was the only blue, bold item in the menu and
          read as permanently selected. It highlights on hover like the rest. */}
      <MainMenu.DefaultItems.CommandPalette />
      <MainMenu.DefaultItems.Help />
      {/* cloud boards autosave — "Reset the canvas" would wipe the board on
          the server too; the dashboard's Trash is the sanctioned delete path */}
      {!getCloudBoardId() && <MainMenu.DefaultItems.ClearCanvas />}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences
        additionalItems={
          <MainMenu.ItemCustom>
            <LanguageList style={{ width: "100%" }} />
          </MainMenu.ItemCustom>
        }
      />
    </MainMenu>
  );
});
